export type PlayerProfileTab =
  | "overview"
  | "schedule"
  | "performance"
  | "media"
  | "documents";

export type SchoolPlayerProfileTabProps = {
  athlete: any;
  athleteLoading: boolean;
  linkedSports: any[];
  linkedTeams: any[];
  playerId: string;
  schoolId: string;
  schoolPlayer: any;
};

export const PLAYER_PROFILE_TABS: Array<{ id: PlayerProfileTab; label: string }> = [
  { id: "overview", label: "Overview" },
  { id: "schedule", label: "Schedule" },
  { id: "performance", label: "Performance" },
  { id: "media", label: "Media" },
  { id: "documents", label: "Documents" },
];

export const parsePlayerProfileTab = (search: string): PlayerProfileTab => {
  const tab = new URLSearchParams(search).get("tab") as PlayerProfileTab | null;
  if (tab && PLAYER_PROFILE_TABS.some((entry) => entry.id === tab)) {
    return tab;
  }
  return "overview";
};
